import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  usersThunk,
  addUsersThunk,
  getAllUsersThunk,
  getAllSkillsThunk,
} from "./thunk";

const usersInitialState = {
  status: "idle",
  data: {},
  error: {},
};
const getAllUsersInitialState = {
  status: "idle",
  data: {},
  error: {},
};
const getAllSkillsInitialState = {
  status: "idle",
  data: {},
  error: {},
};
const addUsersInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const usersSlice = createSlice({
  name: "users",
  initialState: usersInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(usersThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(usersThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(usersThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const getAllUsersSlice = createSlice({
  name: "getAllUsers",
  initialState: getAllUsersInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsersThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getAllUsersThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(getAllUsersThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const getAllSkillsSlice = createSlice({
  name: "getAllSkills",
  initialState: getAllSkillsInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSkillsThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getAllSkillsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(getAllSkillsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});
const addUsersSlice = createSlice({
  name: "addUsers",
  initialState: addUsersInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUsersThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(addUsersThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(addUsersThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

export const { reset: resetUsers } = usersSlice.actions;
export const { reset: resetGetAllUsers } = getAllUsersSlice.actions;
export const { reset: resetGetAllSkills } = getAllSkillsSlice.actions;
export const { reset: resetAddUsers } = addUsersSlice.actions;

const reducers = combineReducers({
  users: usersSlice.reducer,
  getAllUsers: getAllUsersSlice.reducer,
  getAllSkills: getAllSkillsSlice.reducer,
  addUsers: addUsersSlice.reducer,
});

export default reducers;
